import React from 'react';

import BaseComponent from '../../../baseClasses/BaseComponent';
import MultiFileUploader from '../../../components/MultiFileUploader';
import ReferenceDocumentUploadCard from './ReferenceDocumentUploadCard';
import './ReferenceDocumentsUploader.scss';

// Change DialogButton to the appropriate name
class ReferenceDocumentsUploader extends BaseComponent {

  handleCreateUploadCards(){

    if(this.props.files.length > 0){
      let files = this.props.files.map(file => {
        return <ReferenceDocumentUploadCard key={'ref-upload-'+ Math.floor(Math.random() * 1000)}file={file}/>;
      });
      return files;
    }
    else return null;
  }

  render() {

    let uploadCards = this.handleCreateUploadCards();
    return (
      <div className="ref-docs-upload-popout-container" >
        <div className="arrow-up" />
        <MultiFileUploader
          handleFileSelect={this.props.handleFileSelect}
          shouldGenerateImagePreview={true}
        />
        {uploadCards && 
          <div className='upload-feedback'>
            <div className='uploading-title'>UPLOADS</div>
            <div className='upload-cards-container'>
              {uploadCards}
            </div>
          </div>
        }
      
      </div>
    );
  }
}

export default ReferenceDocumentsUploader;



// WEBPACK FOOTER //
// ./src/containers/ReferenceDocumentsLibrary/ReferenceDocumentsUploader/index.js